import Vue from 'vue'
import Router from 'vue-router'
// 定义路由组件
// import footer from'@/components/footer'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  //base:'h5',
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/page/home')
    },
    {
      path: '/multiRecharge',
      name: 'multiRecharge',
      component: () => import('@/page/multiRecharge')
    },
    {
      path: '/choice',
      name: 'choice',
      component: () => import('@/page/choice')
    },
    {
      path: '/historycard',
      name: 'historycard',
      component: () => import('@/page/historycard')
    },
    {
      path: '/childOrders',
      name: 'childOrders',
      component: () => import('@/page/childOrders')
    },
    {
      path: '/lifehistory',
      name: 'lifehistory',
      component: () => import('@/page/lifehistory')
    },
    {
      path: '/rehistory',
      name: 'rehistory',
      component: () => import('@/page/rehistory')
    },
    {
      path: '/placeOrder',
      name: 'placeOrder',
      component: () => import('@/page/placeOrder')
    },
    {
      path: '/orderSuccess',
      name: 'orderSuccess',
      component: () => import('@/page/orderSuccess')
    },
    {
      path: '/lifepay',
      name: 'lifepay',
      component: () => import('@/page/lifepay')
    },
    {
      path: '/customer',
      name: 'customer',
      component: () => import('@/page/customer')
    },
    {
      path: '/mine',
      name: 'mine',
      component: () => import('@/page/mine')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/page/login')
    },
    {
      path: '/hongbao',
      name: 'hongbao',
      component: () => import('@/page/hongbao')
    },
    {
      path: '/wallet',
      name: 'wallet',
      component: () => import('@/page/wallet')
    },
    {
      path: '/proposal',
      name: 'proposal',
      component: () => import('@/page/proposal')
    },
    {
      path: '/phoneset',
      name: 'phoneset',
      component: () => import('@/page/phoneset')
    },
    {
      path: '/goods',
      name: 'goods',
      component: () => import('@/page/goods')
    },
    {
      path: '/integral',
      name: 'integral',
      component: () => import('@/page/integral')
    },
    {
      path: '/coupons',
      name: 'coupons',
      component: () => import('@/page/coupons')
    },
    {
      path: '/rule',
      name: 'rule',
      component: () => import('@/page/rule')
    },
    {
      path: '/recharge',
      name: 'recharge',
      component: () => import('@/page/recharge')
    },
    {
      path: '/encryption',
      name: 'encryption',
      component: () => import('@/page/encryption')
    },
    {
      path: '/complaintRecords',
      name: 'complaintRecords',
      component: () => import('@/page/complaintRecords')
    },
    {
      path: '/myEsim',
      name: 'myEsim',
      component: () => import('@/page/myEsim')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js